import { Swiper } from 'swiper/react'
import { styled, css } from '@mui/material'

export const CarouselWrapper = styled(Swiper)(
  ({ theme }) => css`
    width: 100%;

    .swiper-slide {
      display: flex;
      justify-content: stretch;
      align-items: stretch;
      height: auto;

      > * {
        flex: 1;
      }
    }

    .swiper-pagination {
      position: sticky;
    }

    .swiper-button-next,
    .swiper-button-prev {
      color: ${theme.palette.primary.main};
    }

    .swiper-pagination-bullet {
      width: 20px;
      height: 4px;
      border-radius: 8px;
      background-color: ${theme.palette.primary.main};
    }

    .swiper-pagination-bullets {
      bottom: 0px;
    }

    .swiper-slide img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  `
)

export const ImageWrapper = styled('div')(
  () => css`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    span {
      margin-top: 0.2rem;
      font-size: 0.8rem;
      text-align: center;
    }
  `
)

export const CategoryWrapper = styled('div')(
  ({ theme }) => css`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: ${theme.palette.primary.main};
    color: ${theme.palette.primary.contrastText};
    text-align: center;
    border-radius: 50%;
    span {
      font-size: 9px;
      max-width: 100%;
      font-weight: 600;
    }
  `
)
